import { isEmailValid } from 'ui/pages/helpers';
import { object, string } from 'yup';
import { isCPFValid } from './is-cpf-valid';
import { isResellerCodeValid } from './is-reseller-code-valid';

export const authCredentialsSchema = object({
  username: string()
    .required('CPF, e-mail ou código do Revendedor inválidos.')
    .test({
      name: 'validUsername',
      test: (value) => {
        if (!value) {
          return false;
        }

        const isCpf = isCPFValid(value);
        if (isCpf) {
          return true;
        }

        const isEmail = isEmailValid(value);
        if (isEmail) {
          return true;
        }

        const isResellerCode = isResellerCodeValid(value);
        if (isResellerCode) {
          return true;
        }

        return false;
      },
      message: 'CPF, e-mail ou código do Revendedor inválidos.',
      exclusive: true,
    }),
  password: string().trim().required('A senha é obrigatória.'),
});
